// extracted by mini-css-extract-plugin
module.exports = {"customButtonDownload":"Reports_customButtonDownload__37Cs-","customButtonResolve":"Reports_customButtonResolve__1nBvA"};